import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAiRcQ6mdTO4JCESHbEB2Fue0tev-swMhg",
  authDomain: "ai-paraphaser.firebaseapp.com",
  projectId: "ai-paraphaser",
  storageBucket: "ai-paraphaser.firebasestorage.app",
  messagingSenderId: "998008827612",
  appId: "1:998008827612:web:d088cd11040fc9febbce19",
  measurementId: "G-LKESW6VBET",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const googleProvider = new GoogleAuthProvider();
export default app;
